module.exports = __webpack_public_path__ + "img/kommune-234.c0f36e02.svg";